window.addEventListener("load", (event) => {
    function imgHover() {
        const cards = document.querySelectorAll('.products_grid__item');
        cards.forEach(card => {

            const variantBlock = card.querySelector('.product-variants');
            if (variantBlock) {
                const items = card.querySelectorAll('.product-variants__item');
                let imgs = Array.from(card.querySelectorAll('.products_grid__image .variant-option'));

                items.forEach(item => {
                    item.addEventListener('mouseenter', () => {
                        imgs.forEach(img => img.classList.remove('active'));
                        let signa = item.getAttribute('signature');
                        let img = card.querySelector(`.products_grid__image .variant-option[signature="${signa}"]`)
                        img.classList.add('active');
                    });
                    variantBlock.addEventListener('mouseleave', () => {
                        imgs.forEach(img => img.classList.remove('active'));
                    });
                });

            }

        });
    }
    imgHover();


    if (typeof Ajaxinate !== "undefined") {
        new Ajaxinate({
            method: 'click',
            callback: function () {
                console.log('New page loaded');
                imgHover();
            }
        });
    }
});
